import React from 'react';

interface PileItemProps {
  text: string;
  score?: string;
  category?: 'success' | 'warning' | 'danger' | 'default';
  icon?: string;
  showIcon?: boolean;
  iconStyle?: 'outlined' | 'filled' | 'rounded' | 'sharp' | 'two-tone';
  thresholdHigh?: number;
  thresholdLow?: number;
  scoreValue?: number;
  maxScore?: number;
  title?: string;
  textStyle?: 'normal' | 'threshold';
  numberStyle?: 'normal' | 'threshold';
  boxStyle?: 'normal' | 'threshold';
}

const PileItem: React.FC<PileItemProps> = ({
  text,
  score,
  category,
  icon,
  showIcon = false,
  iconStyle = 'outlined',
  thresholdHigh,
  thresholdLow,
  scoreValue,
  maxScore,
  title,
  textStyle = 'normal',
  numberStyle = 'normal',
  boxStyle = 'normal'
}) => {
  // Determine category based on thresholds if provided
  let finalCategory = category || 'default';
  let finalIcon = icon;
  let finalShowIcon = showIcon;

  if (thresholdHigh !== undefined && thresholdLow !== undefined && scoreValue !== undefined && maxScore !== undefined) {
    const percentage = (scoreValue / maxScore) * 100;
    
    if (percentage >= thresholdHigh) {
      finalCategory = 'success';
      finalShowIcon = true;
      finalIcon = finalIcon || 'check_circle';
    } else if (percentage >= thresholdLow) {
      finalCategory = 'warning';
      finalShowIcon = true;
      finalIcon = finalIcon || 'warning';
    } else {
      finalCategory = 'danger';
      finalShowIcon = true;
      finalIcon = finalIcon || 'error';
    }
  }

  const pileClass = `pile-item ${score ? 'pile-item-with-score' : ''} ${boxStyle === 'threshold' && finalCategory !== 'default' ? `pile-item-${finalCategory}` : ''}`;
  const textClass = `pile-item-text ${textStyle === 'threshold' && finalCategory !== 'default' ? `pile-item-text-${finalCategory}` : ''}`;
  const scoreClass = score ? `pile-item-score ${numberStyle === 'threshold' && finalCategory !== 'default' ? `pile-item-score-${finalCategory}` : ''}` : '';

  return (
    <div className={pileClass} title={title}>
      {finalShowIcon && finalIcon && (
        <span className={`pile-item-icon material-symbols-${iconStyle}`}>{finalIcon}</span>
      )}
      <span className={textClass}>{text}</span>
      {score && <span className={scoreClass}>{score}</span>}
    </div>
  );
};

export default PileItem; 